import React, { useState } from 'react';
import { Button, CardBody } from 'reactstrap';
import MultiLocationPicker from '../AdvancedLocationPicker/MultiLocationPicker';
import View from '../../../elements/View';
import { POINT_TYPE_LABELS_BY_LANG } from '../PointType';
export var TabPoints = function (props) {
    var locationsPoints = props.locationsPoints, _a = props.language, language = _a === void 0 ? 'es' : _a, onChangeLocationPoints = props.onChangeLocationPoints;
    var _b = useState(locationsPoints), points = _b[0], setPoints = _b[1];
    var handleChange = function (updatedPoints) {
        setPoints(updatedPoints);
    };
    var typeOptions = [
        { value: 'experience', label: POINT_TYPE_LABELS_BY_LANG[language].experience },
        { value: 'pickup', label: POINT_TYPE_LABELS_BY_LANG[language].pickup },
        { value: 'dropoff', label: POINT_TYPE_LABELS_BY_LANG[language].dropoff },
        { value: 'waypoint', label: POINT_TYPE_LABELS_BY_LANG[language].waypoint },
        { value: 'parking', label: POINT_TYPE_LABELS_BY_LANG[language].parking },
    ];
    return (React.createElement(View, null,
        React.createElement(CardBody, null,
            React.createElement("div", null,
                React.createElement(MultiLocationPicker, { points: points, onChange: handleChange, typeOptions: typeOptions }),
                React.createElement(Button, { onClick: function () {
                        onChangeLocationPoints(points);
                    } }, 'Guardar puntos')))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/LocationPicker/container/TabPoints.tsx
// module id = 1531
// module chunks = 0